import React from 'react';

import { createClientProductFormValues } from 'utils/clientProductFormUtils';
import { stringIsEmtyOrDigits } from 'utils/stringUtils';
import { ClientProductFormValues } from 'types/clientProductFormTypes';

export const useClientProductFormValues = () => {
  const [formValues, setFormValues] = React.useState<ClientProductFormValues>(
    createClientProductFormValues
  );

  const setDiscountPercent = React.useCallback((nextValue: string) => {
    if (stringIsEmtyOrDigits(nextValue)) {
      setFormValues((prev) => {
        const nextValueNumber = Number(nextValue);

        const currentPercentNumber = Number(prev.partnerPercent);

        const nextSum = currentPercentNumber + nextValueNumber;

        if (nextSum <= 100) {
          return {
            ...prev,
            discountPercent: nextValue,
          };
        }

        return prev;
      });
    }
  }, []);

  const setPartnerPercent = React.useCallback((nextValue: string) => {
    if (stringIsEmtyOrDigits(nextValue)) {
      setFormValues((prev) => {
        const nextValueNumber = Number(nextValue);

        const currentDiscountNumber = Number(prev.discountPercent);

        const nextSum = currentDiscountNumber + nextValueNumber;

        if (nextSum <= 100) {
          return {
            ...prev,
            partnerPercent: nextValue,
          };
        }

        return prev;
      });
    }
  }, []);

  return {
    formValues,
    setDiscountPercent,
    setPartnerPercent,
  };
};
